import "slick-carousel"

export default class DafYomiSlider {
    constructor() {
        this.addEvents();
    }

    addEvents() {
        this.initSlickCarousel();
    }

    initSlickCarousel() {

        $('.daf-yomi-grid >.jet-listing-grid--blocks > .jet-listing-grid > .jet-listing-grid__items').slick({
            slidesToShow: 1,
            variableWidth: true,
            infinite: false,
            arrows: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        rows: 3,
                        slidesPerRow: 2,
                        draggable: false,
                        variableWidth: false,
                    }
                },
                {
                    breakpoint: 1279,
                    settings: 'unslick'
                }
            ]
        });
    }
}